export const isValidImageFile = async (file: File): Promise<boolean> => {
  if (!file.type.startsWith('image/')) return true;

  try {
    const imageBitmap = await createImageBitmap(file);
    imageBitmap.close();
    return true;
  } catch {
    return false;
  }
};
